var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuard3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1253 16.8541L16.7087 19.4374L22.5212 13.6249M28.3337 17.4999C28.3337 23.8399 21.4181 28.4512 18.9019 29.919C18.6159 30.0859 18.4729 30.1693 18.2712 30.2126C18.1145 30.2462 17.8861 30.2462 17.7295 30.2126C17.5277 30.1693 17.3847 30.0859 17.0987 29.919C14.5825 28.4512 7.66699 23.8399 7.66699 17.4999V11.3226C7.66699 10.2899 7.66699 9.77353 7.83589 9.32968C7.98509 8.93758 8.22755 8.58772 8.5423 8.31033C8.8986 7.99634 9.38207 7.81504 10.349 7.45243L17.2747 4.85531C17.5432 4.75461 17.6774 4.70426 17.8156 4.6843C17.9381 4.66659 18.0626 4.66659 18.185 4.6843C18.3232 4.70426 18.4574 4.75461 18.726 4.85531L25.6516 7.45243C26.6186 7.81504 27.1021 7.99634 27.4583 8.31033C27.7731 8.58772 28.0155 8.93758 28.1647 9.32968C28.3337 9.77353 28.3337 10.2899 28.3337 11.3226V17.4999Z",
    stroke: "#0C9D61",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuard3);
export default __webpack_public_path__ + "static/media/Guard3.221d6fcdd50ce07de0f595bfda72f8be.svg";
export { ForwardRef as ReactComponent };